'use client'
import React, { HTMLAttributes } from 'react'

import { Locale } from '../../../i18n.config';
import Image from 'next/image';
import RedirectButton from '../RedirectButton';
import parser from 'html-react-parser';
import { getTranslation } from '@/lib/utils';
import { parseOptions } from '@/utils/parseOptions';

interface ISicilyMapZoneProps extends HTMLAttributes<HTMLDivElement> {
  region: number;
  alt?: string;
};

const imageSlug = [
  "sicily-west",
  "sicily-north",
  "sicily-east",
  "sicily-south",
  "puglia-north",
  "puglia-south",
  "puglia-central",
]

export const SicilyMapZone: React.FC<ISicilyMapZoneProps> = ({ alt = '', region }) => {
  return (
    <div className="flex h-full aspect-square overflow-hidden relative scale-150">
      {
        <Image
          src={`https://villatravellers-prod.s3.eu-west-2.amazonaws.com/assets/images/maps/guides/${imageSlug[region - 1]}@2x.png`}
          alt={alt}
          fill
          onError={e => e.currentTarget.classList.add('invisible')}
          className={
            'group-hover:-translate-x-1/2 z-10 scale-[2] translate-x-1/2 absolute opacity-90 duration-0 '
          }
          sizes="20vw"
          quality={100}
          style={{
            objectFit: 'contain',
          }}
        />
      }
    </div>
  )
}